import { css } from 'styled-components';

export default css`
  section[data-litium-block-id] {
    background-position: center;
    background-size: cover;
    position: relative;

    .block-background-image {
      position: absolute;
      inset: 0;
      z-index: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
`;
